"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alphaToHex = function (alpha) {
    return Math.round(alpha * 255)
        .toString(16)
        .substring(0, 2);
};
var hexAlpha = function (value, alpha) {
    return "".concat(value).concat(alphaToHex(alpha));
};
exports.default = hexAlpha;
//# sourceMappingURL=hexAlpha.js.map